import { render, staticRenderFns } from "./CreateForm - 副本.vue?vue&type=template&id=f1a48e5a&scoped=true"
import script from "./CreateForm - 副本.vue?vue&type=script&lang=js"
export * from "./CreateForm - 副本.vue?vue&type=script&lang=js"
import style0 from "./CreateForm - 副本.vue?vue&type=style&index=0&id=f1a48e5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a48e5a",
  null
  
)

export default component.exports